import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_PROPERTY_AI_BACKEND_URL || process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/property-ai`;

const api = axios.create({
  baseURL: API,
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Properties
export const searchProperties = (params) => api.get('/properties/search', { params });
export const getFeaturedProperties = () => api.get('/properties/featured');
export const getProperty = (id) => api.get(`/properties/${id}`);
export const getCities = () => api.get('/properties/cities');

// Valuation
export const getValuation = (data) => api.post('/valuation/estimate', data);

// AI Chat
export const sendChatMessage = (data) => api.post('/ai/chat', data);
export const getSuggestedPrompts = (params) => api.get('/ai/prompts', { params });

// Affordability
export const calculateAffordability = (data) => api.post('/affordability/calculate', data);

// Mortgage
export const calculateMortgage = (data) => api.post('/mortgage/calculate', data);

// Neighborhoods
export const getNeighborhoods = (params) => api.get('/neighborhoods', { params });
export const getNeighborhood = (id) => api.get(`/neighborhoods/${id}`);

// Agents
export const getAgent = (id) => api.get(`/agents/${id}`);

// Market Stats
export const getMarketStats = () => api.get('/market/stats');

export default api;

